angular.module('elfium').service('elfiumPageAccessService', ['elfiumLoginService', 'PAGE',
    function (elfiumLoginService, PAGE) {
        var that = this;
        that.canAccessPage = function (pageName, pageAccess) {
            if (angular.isDefined(PAGE[pageName])) {
                var pageCode = Math.pow(2, PAGE[pageName]);
                return pageCode & pageAccess;
            } else {
                return true;
            }            
        };
        that.addAccessToPage = function (pageName, pageAccess) {
            var pageCode = Math.pow(2, PAGE[pageName]);
            return pageAccess | pageCode;
        };
        that.removeAccessToPage = function (pageName, pageAccess) {
            var pageCode = Math.pow(2, PAGE[pageName]);
            return pageAccess ^ pageCode;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumPageAccessService.ts